import React, {useEffect, useState} from "react";
import HelperService from "../services/helper-service";
import EventScheduleCell from "./event-schedule-cell";

//mode = trainerDetail || schedule
export default function EventSchedule({events, mode="schedule", link=null, trainer=null, classes='', linkReplace="EID", callback = null, ...props}) {
    const [groupedEvents, setGroupedEvents] = useState([]);
    const dayjs = HelperService.getDayjs();

    useEffect(() => {
        if (events?.length>0){
            let g = {};

            for (let i = 0; i < events?.length; i++) {
                const d = dayjs(events[i]?.datetime,  'x').tz(events[i]?.timezone);
                let dk = d.format('YYYY-MM-DD');

                if (!g[dk]){
                    let header = null;
                    if (!header){
                        header = d.isYesterday() ? 'Yesterday' : null;
                    }
                    if (!header){
                        header = d.isToday() ? 'Today' : null;
                    }
                    if (!header){
                        header = d.isTomorrow() ? 'Tomorrow' : null;
                    }
                    if (!header){
                        header = d.format('dddd, D MMM YYYY');
                    }
                    g[dk] = {
                        key: dk,
                        date: d,
                        header: header,
                        events: []
                    }
                }
                g[dk].events.push(events[i]);
            }
            setGroupedEvents([...Object.values(g)]);
        } else {
            setGroupedEvents([])
        }
    }, [events]);


    return <>
        { groupedEvents?.length>0 &&
            groupedEvents.map(g =>
                <div key={g.key}>
                    <div className="bg-light p-2 rounded-2">{g.header}</div>
                    {g?.events?.map(e =>
                        <div key={e.id} className={''}>
                            <EventScheduleCell mode={mode} event={e} classes={classes} link={link} trainer={trainer || e.trainer } callback={callback}/>
                        </div>
                    )}
                </div>
            )
        }
    </>
}
